module.exports = __webpack_public_path__ + "static/media/totVehicles.840b979f.png";